module.exports = __webpack_public_path__ + "static/benchmarking 3-01136a9d82e7d965b0c4c8de272e720c.png";